export const partners = [
  {
    id: "hjort-knudsen",
    name: "Hjort Knudsen",
    href: "https://hjortknudsen.com",
    src: {
      light: "/assets/images/logos/school-site/partners/hjort-knudsen.png",
      dark: "/assets/images/logos/school-site/partners/hjort-knudsen-dark.png",
    },
    // height: 75,
    height: 45,
  },
  {
    id: "cwrkdiz",
    name: "CWRKDiZ",
    href: "https://cwrkdiz.pila.pl/",
    src: {
      light: "/assets/images/logos/school-site/partners/cwrkdiz.png",
      dark: "/assets/images/logos/school-site/partners/cwrkdiz-dark.png",
    },
    // height: 75,
    height: 40,
  },
  {
    id: "joker",
    name: "Joker Prawo Jazdy",
    href: "https://www.joker-prawojazdy.pl/",
    src: {
      light: "/assets/images/logos/school-site/partners/joker.png",
      dark: "/assets/images/logos/school-site/partners/joker-dark.png",
    },
    // height: 60,
    height: 32,
  },
  {
    id: "venus",
    name: "Salon Kosmetyczny Venus",
    href: "https://www.facebook.com/salonkosmetycznyvenusjadwigaklemens/",
    src: {
      light: "/assets/images/logos/school-site/partners/venus.png",
      dark: "/assets/images/logos/school-site/partners/venus-dark.png",
    },
    // height: 85,
    height: 55,
  },
  {
    id: "dolina-noteci",
    name: "Dolina Noteci",
    href: "https://www.dolina-noteci.pl/",
    src: {
      light: "/assets/images/logos/school-site/partners/dolina-noteci.png",
      dark: "/assets/images/logos/school-site/partners/dolina-noteci-dark.png",
    },
    // height: 80,
    height: 55,
  },
{
    id: "kamar",
    name: "Kamar",
    href: "https://www.kamarwyrzysk.pl/",
    src: {
      light: "/assets/images/logos/school-site/partners/kamar.png",
      dark: "/assets/images/logos/school-site/partners/kamar-dark.png",
    },
    // height: 55,
    height: 25,
  },
];